import { render, staticRenderFns } from "./chargeDetail.vue?vue&type=template&id=6c260faa&scoped=true"
import script from "./chargeDetail.vue?vue&type=script&lang=js"
export * from "./chargeDetail.vue?vue&type=script&lang=js"
import style0 from "./chargeDetail.vue?vue&type=style&index=0&id=6c260faa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c260faa",
  null
  
)

export default component.exports